module.exports = __webpack_public_path__ + "static/img/I.198b5314.svg";